import { IBotState, SceneName } from './BotState';

export const BotVersion = 1;

export enum BotCommand {
  ChangeScene       = 'changeScene',
  GetBotState       = 'getBotState',
  PlayRecordedClip  = 'playRecordedClip',
  StartRecordClip   = 'startRecordClip',
  StopRecordClip    = 'stopRecordClip',
  HangUp            = 'hangUp',
}

// Shared arguments for all commands.
interface IBotCommandArgs<T extends BotCommand> {
  version: 1;
  command: T;
}

export interface IChangeScene {
  playSound?: boolean;
  sceneName: SceneName;
  // Options for VideoPlayer scene
  // TODO: Allow defining scene-specific arg types.
  videoPath?: string;
  overrideAudioPath?: string;
  loopAtEnd?: boolean;
  volume?: number;
}

export enum Streams {
  AudioOnly = 'audioonly',
  VideoOnly = 'videoonly',
  VideoAudio = 'videoaudio',
}

export interface IStartRecordClip {
  streams: Streams;
  upload: boolean;
}

interface IChangeSceneArgs extends IBotCommandArgs<BotCommand.ChangeScene>, IChangeScene {}
interface IGetBotStateArgs extends IBotCommandArgs<BotCommand.GetBotState> {}
interface IPlayRecordClip extends IBotCommandArgs<BotCommand.PlayRecordedClip> {}
interface IStartRecordClipArgs extends IBotCommandArgs<BotCommand.StartRecordClip>, IStartRecordClip {}
interface IStopRecordClipArgs extends IBotCommandArgs<BotCommand.StopRecordClip> {}
interface IHangUpArgs extends IBotCommandArgs<BotCommand.HangUp> {}

// Discriminated union of all the commands.
export type BotCommandArgs =
  IChangeSceneArgs |
  IGetBotStateArgs |
  IPlayRecordClip |
  IStartRecordClipArgs |
  IStopRecordClipArgs |
  IHangUpArgs;

export enum ErrorCode {
  InternalError = 'BotCommand.InternalError',
  InvalidCommand = 'BotCommand.InvalidCommand',
}

export interface IBotCommandAck {
  botState: IBotState;
  errCode?: ErrorCode;
  errDetail?: string;
}
